import { render, staticRenderFns } from "./StatisticsHeatMap.vue?vue&type=template&id=21c4c90f&scoped=true"
import script from "./StatisticsHeatMap.vue?vue&type=script&lang=js"
export * from "./StatisticsHeatMap.vue?vue&type=script&lang=js"
import style0 from "./StatisticsHeatMap.vue?vue&type=style&index=0&id=21c4c90f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c4c90f",
  null
  
)

export default component.exports